const phoneNumberRegex = /^(?:1)*(\d{3})(\d{3})(\d{4})$/;
const groupByParenthesisFormat = '($1) $2-$3';
const groupByHyphenFormat = '$1-$2-$3';

export const formatPhoneNumber = (
  value: string,
  groupByParenthesis: boolean = true,
) => {
  const cleaned = ('' + value).replace(/\D/g, '');
  const match = cleaned.match(phoneNumberRegex);

  if (match) {
    return cleaned.replace(
      phoneNumberRegex,
      groupByParenthesis ? groupByParenthesisFormat : groupByHyphenFormat,
    );
  }
  return '';
};

export const formatLast4PhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return '';
  }

  const last4 = phoneNumber.slice(-4) || 'xxxx';
  return `(xxx) xxx-${last4}`;
};
